/**
 * @file constants 用到的常量
 * @author sunwen05
 */

// 默认options
export const defaultOptions = {
    layouts: {
        formItemLabelLayout: {
            labelAlign: 'left',
            labelCol: {xs: {span: 24}, sm: {span: 4}},
            wrapperCol: {xs: {span: 24}, sm: {span: 20}}
        },
        formItemEmptyLabelLayout: {
            labelAlign: 'left',
            wrapperCol: {span: 20, offset: 4}
        },
        formItemNoneLayout: {
            labelAlign: 'left',
            wrapperCol: {span: 24, offset: 0}
        }
    }
};
